import React, { useEffect, useRef, useState } from "react";
import { OlaMaps } from "olamaps-web-sdk";
import axios from "axios";
import { OLA_MAP_KEY } from "../redux/api/Constants";

function OLAMap() {
  const mapContainerRef = useRef(null);
  const markerRef = useRef(null); // Ref for marker
  const mapRef = useRef(null); // Ref for map
  const [long, setLong] = useState(80.217639);
  const [lat, setLat] = useState(13.05321);
  const [address, setAddress] = useState("");
  const [addressList, setAddressList] = useState([]);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    if (!mapContainerRef.current) return;

    const olaMaps = new OlaMaps({
      apiKey: OLA_MAP_KEY,
    });

    const myMap = olaMaps.init({
      style:
        "https://api.olamaps.io/tiles/vector/v1/styles/default-light-standard/style.json",
      container: mapContainerRef.current,
      center: [long, lat],
      zoom: 15,
    });

    mapRef.current = myMap; // save map reference

    myMap.on("load", () => {
      const olaIcon = document.createElement("div");
      olaIcon.classList.add("olalogo");

      const draggableMarker = olaMaps
        .addMarker({
          offset: [0, 6],
          anchor: "bottom",
          color: "red",
          draggable: true,
        })
        .setLngLat([long, lat])
        .addTo(myMap);

      markerRef.current = draggableMarker; // Save draggable marker

      // Initial address fetch
      handleMarkerPosition(lat, long);

      // Dragend Event
      draggableMarker.on("dragend", () => {
        const lngLat = draggableMarker.getLngLat();
        console.log("Marker moved to:", lngLat);
        setLong(lngLat.lng);
        setLat(lngLat.lat);
        handleMarkerPosition(lngLat.lat, lngLat.lng);
      });
    });

    return () => {
      myMap.remove();
    };
  }, []);

  const handleAutoComplete = (event) => {
    setSearchText(event);
    if (event.length < 2) {
      setAddressList([]);
      return;
    }

    let url_ = `https://api.olamaps.io/places/v1/autocomplete?location=${lat},${long}&input=${event}&api_key=${OLA_MAP_KEY}`;
    if (event.length > 2) {
      axios
        .get(url_)
        .then((res) => {
          console.log("Autocomplete response:", res);
          setAddressList(res?.data?.predictions || []);
        })
        .catch((err) => {
          console.log("Autocomplete error:", err);
        });
    }
  };

  const handleMarkerPosition = (lat_, long_) => {
    let url_ = `https://api.olamaps.io/places/v1/reverse-geocode?latlng=${lat_},${long_}&api_key=${OLA_MAP_KEY}`;
    axios
      .get(url_)
      .then((res) => {
        console.log("Reverse Geocode response:", res);
        setLat(lat_);
        setLong(long_);
        setAddress(
          res?.data?.results?.[0]?.formatted_address || "Address not found"
        );
      })
      .catch((err) => {
        console.log("Reverse Geocode error:", err);
      });

    // Move marker if available
    if (markerRef.current) {
      markerRef.current.setLngLat([long_, lat_]);
    }

    // Move map center if available
    if (mapRef.current) {
      mapRef.current.flyTo({
        center: [long_, lat_],
        zoom: 15,
        speed: 1,
        curve: 1.42,
      });
    }
  };

  console.log("Current address:", address);

  return (
    <div className="App">
      <div style={{ position: "absolute", zIndex: 1, top: 10 }}>
        <input
          placeholder="Search address"
          onChange={(e) => handleAutoComplete(e.target.value)}
          value={searchText}
          style={{ width: "300px", padding: "8px", marginBottom: "10px" }}
        />

        <div>
          <ul>
            {addressList?.map((item, index) => (
              <li
                key={index}
                style={{ listStyle: "none", marginBottom: "5px" }}
              >
                <button
                  className="cust-btn"
                  onClick={() => {
                    handleMarkerPosition(
                      item?.geometry?.location?.lat,
                      item?.geometry?.location?.lng
                    );
                    setSearchText(item?.description); // update search input with selected address
                    setAddressList([]); // clear suggestion list
                  }}
                  style={{ width: "100%", textAlign: "left", padding: "6px" }}
                >
                  {item?.description}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div
        ref={mapContainerRef}
        style={{
          width: "100%",
          height: "80vh",
          // marginTop: "20px",
        }}
      />

      <div
        style={{ position: "absolute", zIndex: 1, bottom: 0, padding: "10px" }}
      >
        <h3>Marker Position:</h3>
        <p>
          <strong>Latitude:</strong> {lat}
        </p>
        <p>
          <strong>Longitude:</strong> {long}
        </p>
        <h3>Address:</h3>
        <p>{address || "Fetching address..."}</p>
      </div>
    </div>
  );
}

export default OLAMap;
